import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="w-full bg-background-950 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="text-xl font-bold font-heading text-accent-500">黑料</span>
              <span className="text-xl font-bold font-heading text-background-50">bu</span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              黑料bu是专注收录网络热点黑料的资讯聚合平台，第一时间汇聚明星、网红、大V的最新黑料动态。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">资讯分类</h4>
            <ul className="space-y-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-accent-500 transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">关于我们</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-500 transition-colors">
                  品牌介绍
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-500 transition-colors">
                  口碑评价
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-accent-500 transition-colors">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-200 mb-4">免责声明</h4>
            <p className="text-sm text-background-400 leading-relaxed">
              本站内容来源于网络公开信息及用户投稿，不代表本站立场。如有不实信息，请联系我们进行处理。本站保留对内容的最终解释权。
            </p>
          </div>
        </div>

        <div className="border-t border-background-800 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-background-500">
            &copy; 2026 黑料bu - 黑料资讯聚合平台. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-accent-500 transition-colors">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-500 transition-colors">用户协议</a>
            <a href="#" className="text-xs text-background-500 hover:text-accent-500 transition-colors">投诉建议</a>
          </div>
        </div>
      </div>
    </footer>
  );
}